import * as Yup from 'yup';
import { TFunction } from 'i18next';

export const TimeAttendanceSearchValidationSchema = (t: TFunction) =>
  Yup.object({
    startDate: Yup.string().required(t('valid_err_required')),
    endDate: Yup.string().required(t('valid_err_required')),
    branch: Yup.array().of(Yup.string()).min(1, t('valid_err_required')),
    officeID: Yup.number().nullable(),
  });

export type TimeAttendanceSearchValidationSchemaType = ReturnType<
  typeof TimeAttendanceSearchValidationSchema
>;
